const COUNTRY_DIAL_ROWS = [
  {
    name: "Afghanistan",
    dial_code: "+93",
    code: "AF",
    unicodeFlag: "🇦🇫",
    value: "Afghanistan",
    label: "Afghanistan",
  },
  {
    name: "Albania",
    dial_code: "+355",
    code: "AL",
    unicodeFlag: "🇦🇱",
    value: "Albania",
    label: "Albania",
  },
  {
    name: "Algeria",
    dial_code: "+213",
    code: "DZ",
    unicodeFlag: "🇩🇿",
    value: "Algeria",
    label: "Algeria",
  },
  {
    name: "AmericanSamoa",
    dial_code: "+1 684",
    code: "AS",
    unicodeFlag: "",
    value: "AmericanSamoa",
    label: "AmericanSamoa",
  },
  {
    name: "Andorra",
    dial_code: "+376",
    code: "AD",
    unicodeFlag: "🇦🇩",
    value: "Andorra",
    label: "Andorra",
  },
  {
    name: "Angola",
    dial_code: "+244",
    code: "AO",
    unicodeFlag: "🇦🇴",
    value: "Angola",
    label: "Angola",
  },
  {
    name: "Anguilla",
    dial_code: "+1 264",
    code: "AI",
    unicodeFlag: "🇦🇮",
    value: "Anguilla",
    label: "Anguilla",
  },
  {
    name: "Antarctica",
    dial_code: null,
    code: "AQ",
    unicodeFlag: "",
    value: "Antarctica",
    label: "Antarctica",
  },
  {
    name: "Antigua and Barbuda",
    dial_code: "+1268",
    code: "AG",
    unicodeFlag: "🇦🇬",
    value: "Antigua and Barbuda",
    label: "Antigua and Barbuda",
  },
  {
    name: "Argentina",
    dial_code: "+54",
    code: "AR",
    unicodeFlag: "🇦🇷",
    value: "Argentina",
    label: "Argentina",
  },
  {
    name: "Armenia",
    dial_code: "+374",
    code: "AM",
    unicodeFlag: "🇦🇲",
    value: "Armenia",
    label: "Armenia",
  },
  {
    name: "Aruba",
    dial_code: "+297",
    code: "AW",
    unicodeFlag: "🇦🇼",
    value: "Aruba",
    label: "Aruba",
  },
  {
    name: "Australia",
    dial_code: "+61",
    code: "AU",
    unicodeFlag: "🇦🇺",
    value: "Australia",
    label: "Australia",
  },
  {
    name: "Austria",
    dial_code: "+43",
    code: "AT",
    unicodeFlag: "🇦🇹",
    value: "Austria",
    label: "Austria",
  },
  {
    name: "Azerbaijan",
    dial_code: "+994",
    code: "AZ",
    unicodeFlag: "🇦🇿",
    value: "Azerbaijan",
    label: "Azerbaijan",
  },
  {
    name: "Bahamas",
    dial_code: "+1 242",
    code: "BS",
    unicodeFlag: "🇧🇸",
    value: "Bahamas",
    label: "Bahamas",
  },
  {
    name: "Bahrain",
    dial_code: "+973",
    code: "BH",
    unicodeFlag: "🇧🇭",
    value: "Bahrain",
    label: "Bahrain",
  },
  {
    name: "Bangladesh",
    dial_code: "+880",
    code: "BD",
    unicodeFlag: "🇧🇩",
    value: "Bangladesh",
    label: "Bangladesh",
  },
  {
    name: "Barbados",
    dial_code: "+1 246",
    code: "BB",
    unicodeFlag: "🇧🇧",
    value: "Barbados",
    label: "Barbados",
  },
  {
    name: "Belarus",
    dial_code: "+375",
    code: "BY",
    unicodeFlag: "🇧🇾",
    value: "Belarus",
    label: "Belarus",
  },
  {
    name: "Belgium",
    dial_code: "+32",
    code: "BE",
    unicodeFlag: "🇧🇪",
    value: "Belgium",
    label: "Belgium",
  },
  {
    name: "Belize",
    dial_code: "+501",
    code: "BZ",
    unicodeFlag: "🇧🇿",
    value: "Belize",
    label: "Belize",
  },
  {
    name: "Benin",
    dial_code: "+229",
    code: "BJ",
    unicodeFlag: "🇧🇯",
    value: "Benin",
    label: "Benin",
  },
  {
    name: "Bermuda",
    dial_code: "+1 441",
    code: "BM",
    unicodeFlag: "🇧🇲",
    value: "Bermuda",
    label: "Bermuda",
  },
  {
    name: "Bhutan",
    dial_code: "+975",
    code: "BT",
    unicodeFlag: "🇧🇹",
    value: "Bhutan",
    label: "Bhutan",
  },
  {
    name: "Bolivia, Plurinational State of",
    dial_code: "+591",
    code: "BO",
    unicodeFlag: "",
    value: "Bolivia, Plurinational State of",
    label: "Bolivia, Plurinational State of",
  },
  {
    name: "Bosnia and Herzegovina",
    dial_code: "+387",
    code: "BA",
    unicodeFlag: "🇧🇦",
    value: "Bosnia and Herzegovina",
    label: "Bosnia and Herzegovina",
  },
  {
    name: "Botswana",
    dial_code: "+267",
    code: "BW",
    unicodeFlag: "🇧🇼",
    value: "Botswana",
    label: "Botswana",
  },
  {
    name: "Brazil",
    dial_code: "+55",
    code: "BR",
    unicodeFlag: "🇧🇷",
    value: "Brazil",
    label: "Brazil",
  },
  {
    name: "British Indian Ocean Territory",
    dial_code: "+246",
    code: "IO",
    unicodeFlag: "🇮🇴",
    value: "British Indian Ocean Territory",
    label: "British Indian Ocean Territory",
  },
  {
    name: "Brunei Darussalam",
    dial_code: "+673",
    code: "BN",
    unicodeFlag: "",
    value: "Brunei Darussalam",
    label: "Brunei Darussalam",
  },
  {
    name: "Bulgaria",
    dial_code: "+359",
    code: "BG",
    unicodeFlag: "🇧🇬",
    value: "Bulgaria",
    label: "Bulgaria",
  },
  {
    name: "Burkina Faso",
    dial_code: "+226",
    code: "BF",
    unicodeFlag: "🇧🇫",
    value: "Burkina Faso",
    label: "Burkina Faso",
  },
  {
    name: "Burundi",
    dial_code: "+257",
    code: "BI",
    unicodeFlag: "🇧🇮",
    value: "Burundi",
    label: "Burundi",
  },
  {
    name: "Cambodia",
    dial_code: "+855",
    code: "KH",
    unicodeFlag: "🇰🇭",
    value: "Cambodia",
    label: "Cambodia",
  },
  {
    name: "Cameroon",
    dial_code: "+237",
    code: "CM",
    unicodeFlag: "🇨🇲",
    value: "Cameroon",
    label: "Cameroon",
  },
  {
    name: "Canada",
    dial_code: "+1",
    code: "CA",
    unicodeFlag: "🇨🇦",
    value: "Canada",
    label: "Canada",
  },
  {
    name: "Cape Verde",
    dial_code: "+238",
    code: "CV",
    unicodeFlag: "🇨🇻",
    value: "Cape Verde",
    label: "Cape Verde",
  },
  {
    name: "Cayman Islands",
    dial_code: "+ 345",
    code: "KY",
    unicodeFlag: "🇰🇾",
    value: "Cayman Islands",
    label: "Cayman Islands",
  },
  {
    name: "Central African Republic",
    dial_code: "+236",
    code: "CF",
    unicodeFlag: "🇨🇫",
    value: "Central African Republic",
    label: "Central African Republic",
  },
  {
    name: "Chad",
    dial_code: "+235",
    code: "TD",
    unicodeFlag: "🇹🇩",
    value: "Chad",
    label: "Chad",
  },
  {
    name: "Chile",
    dial_code: "+56",
    code: "CL",
    unicodeFlag: "🇨🇱",
    value: "Chile",
    label: "Chile",
  },
  {
    name: "China",
    dial_code: "+86",
    code: "CN",
    unicodeFlag: "🇨🇳",
    value: "China",
    label: "China",
  },
  {
    name: "Christmas Island",
    dial_code: "+61",
    code: "CX",
    unicodeFlag: "🇨🇽",
    value: "Christmas Island",
    label: "Christmas Island",
  },
  {
    name: "Cocos (Keeling) Islands",
    dial_code: "+61",
    code: "CC",
    unicodeFlag: "",
    value: "Cocos (Keeling) Islands",
    label: "Cocos (Keeling) Islands",
  },
  {
    name: "Colombia",
    dial_code: "+57",
    code: "CO",
    unicodeFlag: "🇨🇴",
    value: "Colombia",
    label: "Colombia",
  },
  {
    name: "Comoros",
    dial_code: "+269",
    code: "KM",
    unicodeFlag: "🇰🇲",
    value: "Comoros",
    label: "Comoros",
  },
  {
    name: "Congo",
    dial_code: "+242",
    code: "CG",
    unicodeFlag: "🇨🇬",
    value: "Congo",
    label: "Congo",
  },
  {
    name: "Congo, The Democratic Republic of the",
    dial_code: "+243",
    code: "CD",
    unicodeFlag: "",
    value: "Congo, The Democratic Republic of the",
    label: "Congo, The Democratic Republic of the",
  },
  {
    name: "Cook Islands",
    dial_code: "+682",
    code: "CK",
    unicodeFlag: "🇨🇰",
    value: "Cook Islands",
    label: "Cook Islands",
  },
  {
    name: "Costa Rica",
    dial_code: "+506",
    code: "CR",
    unicodeFlag: "🇨🇰",
    value: "Costa Rica",
    label: "Costa Rica",
  },
  {
    name: "Cote d'Ivoire",
    dial_code: "+225",
    code: "CI",
    unicodeFlag: "",
    value: "Cote d'Ivoire",
    label: "Cote d'Ivoire",
  },
  {
    name: "Croatia",
    dial_code: "+385",
    code: "HR",
    unicodeFlag: "🇭🇷",
    value: "Croatia",
    label: "Croatia",
  },
  {
    name: "Cuba",
    dial_code: "+53",
    code: "CU",
    unicodeFlag: "🇨🇺",
    value: "Cuba",
    label: "Cuba",
  },
  {
    name: "Cyprus",
    dial_code: "+537",
    code: "CY",
    unicodeFlag: "🇨🇾",
    value: "Cyprus",
    label: "Cyprus",
  },
  {
    name: "Czech Republic",
    dial_code: "+420",
    code: "CZ",
    unicodeFlag: "",
    value: "Czech Republic",
    label: "Czech Republic",
  },
  {
    name: "Denmark",
    dial_code: "+45",
    code: "DK",
    unicodeFlag: "",
    value: "Denmark",
    label: "Denmark",
  },
  {
    name: "Djibouti",
    dial_code: "+253",
    code: "DJ",
    unicodeFlag: "",
    value: "Djibouti",
    label: "Djibouti",
  },
  {
    name: "Dominica",
    dial_code: "+1 767",
    code: "DM",
    unicodeFlag: "",
    value: "Dominica",
    label: "Dominica",
  },
  {
    name: "Dominican Republic",
    dial_code: "+1 849",
    code: "DO",
    unicodeFlag: "",
    value: "Dominican Republic",
    label: "Dominican Republic",
  },
  {
    name: "Ecuador",
    dial_code: "+593",
    code: "EC",
    unicodeFlag: "",
    value: "Ecuador",
    label: "Ecuador",
  },
  {
    name: "Egypt",
    dial_code: "+20",
    code: "EG",
    unicodeFlag: "",
    value: "Egypt",
    label: "Egypt",
  },
  {
    name: "El Salvador",
    dial_code: "+503",
    code: "SV",
    unicodeFlag: "",
    value: "El Salvador",
    label: "El Salvador",
  },
  {
    name: "Equatorial Guinea",
    dial_code: "+240",
    code: "GQ",
    unicodeFlag: "",
    value: "Equatorial Guinea",
    label: "Equatorial Guinea",
  },
  {
    name: "Eritrea",
    dial_code: "+291",
    code: "ER",
    unicodeFlag: "",
    value: "Eritrea",
    label: "Eritrea",
  },
  {
    name: "Estonia",
    dial_code: "+372",
    code: "EE",
    unicodeFlag: "",
    value: "Estonia",
    label: "Estonia",
  },
  {
    name: "Ethiopia",
    dial_code: "+251",
    code: "ET",
    unicodeFlag: "",
    value: "Ethiopia",
    label: "Ethiopia",
  },
  {
    name: "Falkland Islands (Malvinas)",
    dial_code: "+500",
    code: "FK",
    unicodeFlag: "",
    value: "Falkland Islands (Malvinas)",
    label: "Falkland Islands (Malvinas)",
  },
  {
    name: "Faroe Islands",
    dial_code: "+298",
    code: "FO",
    unicodeFlag: "",
    value: "Faroe Islands",
    label: "Faroe Islands",
  },
  {
    name: "Fiji",
    dial_code: "+679",
    code: "FJ",
    unicodeFlag: "",
    value: "Fiji",
    label: "Fiji",
  },
  {
    name: "Finland",
    dial_code: "+358",
    code: "FI",
    unicodeFlag: "",
    value: "Finland",
    label: "Finland",
  },
  {
    name: "France",
    dial_code: "+33",
    code: "FR",
    unicodeFlag: "",
    value: "France",
    label: "France",
  },
  {
    name: "French Guiana",
    dial_code: "+594",
    code: "GF",
    unicodeFlag: "",
    value: "French Guiana",
    label: "French Guiana",
  },
  {
    name: "French Polynesia",
    dial_code: "+689",
    code: "PF",
    unicodeFlag: "",
    value: "French Polynesia",
    label: "French Polynesia",
  },
  {
    name: "Gabon",
    dial_code: "+241",
    code: "GA",
    unicodeFlag: "",
    value: "Gabon",
    label: "Gabon",
  },
  {
    name: "Gambia",
    dial_code: "+220",
    code: "GM",
    unicodeFlag: "",
    value: "Gambia",
    label: "Gambia",
  },
  {
    name: "Georgia",
    dial_code: "+995",
    code: "GE",
    unicodeFlag: "",
    value: "Georgia",
    label: "Georgia",
  },
  {
    name: "Germany",
    dial_code: "+49",
    code: "DE",
    unicodeFlag: "",
    value: "Germany",
    label: "Germany",
  },
  {
    name: "Ghana",
    dial_code: "+233",
    code: "GH",
    unicodeFlag: "",
    value: "Ghana",
    label: "Ghana",
  },
  {
    name: "Gibraltar",
    dial_code: "+350",
    code: "GI",
    unicodeFlag: "",
    value: "Gibraltar",
    label: "Gibraltar",
  },
  {
    name: "Greece",
    dial_code: "+30",
    code: "GR",
    unicodeFlag: "",
    value: "Greece",
    label: "Greece",
  },
  {
    name: "Greenland",
    dial_code: "+299",
    code: "GL",
    unicodeFlag: "",
    value: "Greenland",
    label: "Greenland",
  },
  {
    name: "Grenada",
    dial_code: "+1 473",
    code: "GD",
    unicodeFlag: "",
    value: "Grenada",
    label: "Grenada",
  },
  {
    name: "Guadeloupe",
    dial_code: "+590",
    code: "GP",
    unicodeFlag: "",
    value: "Guadeloupe",
    label: "Guadeloupe",
  },
  {
    name: "Guam",
    dial_code: "+1 671",
    code: "GU",
    unicodeFlag: "",
    value: "Guam",
    label: "Guam",
  },
  {
    name: "Guatemala",
    dial_code: "+502",
    code: "GT",
    unicodeFlag: "",
    value: "Guatemala",
    label: "Guatemala",
  },
  {
    name: "Guernsey",
    dial_code: "+44",
    code: "GG",
    unicodeFlag: "",
    value: "Guernsey",
    label: "Guernsey",
  },
  {
    name: "Guinea",
    dial_code: "+224",
    code: "GN",
    unicodeFlag: "",
    value: "Guinea",
    label: "Guinea",
  },
  {
    name: "Guinea-Bissau",
    dial_code: "+245",
    code: "GW",
    unicodeFlag: "",
    value: "Guinea-Bissau",
    label: "Guinea-Bissau",
  },
  {
    name: "Guyana",
    dial_code: "+595",
    code: "GY",
    unicodeFlag: "",
    value: "Guyana",
    label: "Guyana",
  },
  {
    name: "Haiti",
    dial_code: "+509",
    code: "HT",
    unicodeFlag: "",
    value: "Haiti",
    label: "Haiti",
  },
  {
    name: "Holy See (Vatican City State)",
    dial_code: "+379",
    code: "VA",
    unicodeFlag: "",
    value: "Holy See (Vatican City State)",
    label: "Holy See (Vatican City State)",
  },
  {
    name: "Honduras",
    dial_code: "+504",
    code: "HN",
    unicodeFlag: "",
    value: "Honduras",
    label: "Honduras",
  },
  {
    name: "Hong Kong",
    dial_code: "+852",
    code: "HK",
    unicodeFlag: "",
    value: "Hong Kong",
    label: "Hong Kong",
  },
  {
    name: "Hungary",
    dial_code: "+36",
    code: "HU",
    unicodeFlag: "",
    value: "Hungary",
    label: "Hungary",
  },
  {
    name: "Iceland",
    dial_code: "+354",
    code: "IS",
    unicodeFlag: "",
    value: "Iceland",
    label: "Iceland",
  },
  {
    name: "India",
    dial_code: "+91",
    code: "IN",
    unicodeFlag: "",
    value: "India",
    label: "India",
  },
  {
    name: "Indonesia",
    dial_code: "+62",
    code: "ID",
    unicodeFlag: "",
    value: "Indonesia",
    label: "Indonesia",
  },
  {
    name: "Iran, Islamic Republic of",
    dial_code: "+98",
    code: "IR",
    unicodeFlag: "",
    value: "Iran, Islamic Republic of",
    label: "Iran, Islamic Republic of",
  },
  {
    name: "Iraq",
    dial_code: "+964",
    code: "IQ",
    unicodeFlag: "",
    value: "Iraq",
    label: "Iraq",
  },
  {
    name: "Ireland",
    dial_code: "+353",
    code: "IE",
    unicodeFlag: "",
    value: "Ireland",
    label: "Ireland",
  },
  {
    name: "Isle of Man",
    dial_code: "+44",
    code: "IM",
    unicodeFlag: "",
    value: "Isle of Man",
    label: "Isle of Man",
  },
  {
    name: "Israel",
    dial_code: "+972",
    code: "IL",
    unicodeFlag: "",
    value: "Israel",
    label: "Israel",
  },
  {
    name: "Italy",
    dial_code: "+39",
    code: "IT",
    unicodeFlag: "",
    value: "Italy",
    label: "Italy",
  },
  {
    name: "Jamaica",
    dial_code: "+1 876",
    code: "JM",
    unicodeFlag: "",
    value: "Jamaica",
    label: "Jamaica",
  },
  {
    name: "Japan",
    dial_code: "+81",
    code: "JP",
    unicodeFlag: "",
    value: "Japan",
    label: "Japan",
  },
  {
    name: "Jersey",
    dial_code: "+44",
    code: "JE",
    unicodeFlag: "",
    value: "Jersey",
    label: "Jersey",
  },
  {
    name: "Jordan",
    dial_code: "+962",
    code: "JO",
    unicodeFlag: "",
    value: "Jordan",
    label: "Jordan",
  },
  {
    name: "Kazakhstan",
    dial_code: "+7 7",
    code: "KZ",
    unicodeFlag: "",
    value: "Kazakhstan",
    label: "Kazakhstan",
  },
  {
    name: "Kenya",
    dial_code: "+254",
    code: "KE",
    unicodeFlag: "",
    value: "Kenya",
    label: "Kenya",
  },
  {
    name: "Kiribati",
    dial_code: "+686",
    code: "KI",
    unicodeFlag: "",
    value: "Kiribati",
    label: "Kiribati",
  },
  {
    name: "Korea, Democratic People's Republic of",
    dial_code: "+850",
    code: "KP",
    unicodeFlag: "",
    value: "Korea, Democratic People's Republic of",
    label: "Korea, Democratic People's Republic of",
  },
  {
    name: "Korea, Republic of",
    dial_code: "+82",
    code: "KR",
    unicodeFlag: "",
    value: "Korea, Republic of",
    label: "Korea, Republic of",
  },
  {
    name: "Kuwait",
    dial_code: "+965",
    code: "KW",
    unicodeFlag: "",
    value: "Kuwait",
    label: "Kuwait",
  },
  {
    name: "Kyrgyzstan",
    dial_code: "+996",
    code: "KG",
    unicodeFlag: "",
    value: "Kyrgyzstan",
    label: "Kyrgyzstan",
  },
  {
    name: "Lao People's Democratic Republic",
    dial_code: "+856",
    code: "LA",
    unicodeFlag: "",
    value: "Lao People's Democratic Republic",
    label: "Lao People's Democratic Republic",
  },
  {
    name: "Latvia",
    dial_code: "+371",
    code: "LV",
    unicodeFlag: "",
    value: "Latvia",
    label: "Latvia",
  },
  {
    name: "Lebanon",
    dial_code: "+961",
    code: "LB",
    unicodeFlag: "",
    value: "Lebanon",
    label: "Lebanon",
  },
  {
    name: "Lesotho",
    dial_code: "+266",
    code: "LS",
    unicodeFlag: "",
    value: "Lesotho",
    label: "Lesotho",
  },
  {
    name: "Liberia",
    dial_code: "+231",
    code: "LR",
    unicodeFlag: "",
    value: "Liberia",
    label: "Liberia",
  },
  {
    name: "Libyan Arab Jamahiriya",
    dial_code: "+218",
    code: "LY",
    unicodeFlag: "",
    value: "Libyan Arab Jamahiriya",
    label: "Libyan Arab Jamahiriya",
  },
  {
    name: "Liechtenstein",
    dial_code: "+423",
    code: "LI",
    unicodeFlag: "",
    value: "Liechtenstein",
    label: "Liechtenstein",
  },
  {
    name: "Lithuania",
    dial_code: "+370",
    code: "LT",
    unicodeFlag: "",
    value: "Lithuania",
    label: "Lithuania",
  },
  {
    name: "Luxembourg",
    dial_code: "+352",
    code: "LU",
    unicodeFlag: "",
    value: "Luxembourg",
    label: "Luxembourg",
  },
  {
    name: "Macao",
    dial_code: "+853",
    code: "MO",
    unicodeFlag: "",
    value: "Macao",
    label: "Macao",
  },
  {
    name: "Macedonia, The Former Yugoslav Republic of",
    dial_code: "+389",
    code: "MK",
    unicodeFlag: "",
    value: "Macedonia, The Former Yugoslav Republic of",
    label: "Macedonia, The Former Yugoslav Republic of",
  },
  {
    name: "Madagascar",
    dial_code: "+261",
    code: "MG",
    unicodeFlag: "",
    value: "Madagascar",
    label: "Madagascar",
  },
  {
    name: "Malawi",
    dial_code: "+265",
    code: "MW",
    unicodeFlag: "",
    value: "Malawi",
    label: "Malawi",
  },
  {
    name: "Malaysia",
    dial_code: "+60",
    code: "MY",
    unicodeFlag: "",
    value: "Malaysia",
    label: "Malaysia",
  },
  {
    name: "Maldives",
    dial_code: "+960",
    code: "MV",
    unicodeFlag: "",
    value: "Maldives",
    label: "Maldives",
  },
  {
    name: "Mali",
    dial_code: "+223",
    code: "ML",
    unicodeFlag: "",
    value: "Mali",
    label: "Mali",
  },
  {
    name: "Malta",
    dial_code: "+356",
    code: "MT",
    unicodeFlag: "",
    value: "Malta",
    label: "Malta",
  },
  {
    name: "Marshall Islands",
    dial_code: "+692",
    code: "MH",
    unicodeFlag: "",
    value: "Marshall Islands",
    label: "Marshall Islands",
  },
  {
    name: "Martinique",
    dial_code: "+596",
    code: "MQ",
    unicodeFlag: "",
    value: "Martinique",
    label: "Martinique",
  },
  {
    name: "Mauritania",
    dial_code: "+222",
    code: "MR",
    unicodeFlag: "",
    value: "Mauritania",
    label: "Mauritania",
  },
  {
    name: "Mauritius",
    dial_code: "+230",
    code: "MU",
    unicodeFlag: "",
    value: "Mauritius",
    label: "Mauritius",
  },
  {
    name: "Mayotte",
    dial_code: "+262",
    code: "YT",
    unicodeFlag: "",
    value: "Mayotte",
    label: "Mayotte",
  },
  {
    name: "Mexico",
    dial_code: "+52",
    code: "MX",
    unicodeFlag: "",
    value: "Mexico",
    label: "Mexico",
  },
  {
    name: "Micronesia, Federated States of",
    dial_code: "+691",
    code: "FM",
    unicodeFlag: "",
    value: "Micronesia, Federated States of",
    label: "Micronesia, Federated States of",
  },
  {
    name: "Moldova, Republic of",
    dial_code: "+373",
    code: "MD",
    unicodeFlag: "",
    value: "Moldova, Republic of",
    label: "Moldova, Republic of",
  },
  {
    name: "Monaco",
    dial_code: "+377",
    code: "MC",
    unicodeFlag: "",
    value: "Monaco",
    label: "Monaco",
  },
  {
    name: "Mongolia",
    dial_code: "+976",
    code: "MN",
    unicodeFlag: "",
    value: "Mongolia",
    label: "Mongolia",
  },
  {
    name: "Montenegro",
    dial_code: "+382",
    code: "ME",
    unicodeFlag: "",
    value: "Montenegro",
    label: "Montenegro",
  },
  {
    name: "Montserrat",
    dial_code: "+1664",
    code: "MS",
    unicodeFlag: "",
    value: "Montserrat",
    label: "Montserrat",
  },
  {
    name: "Morocco",
    dial_code: "+212",
    code: "MA",
    unicodeFlag: "",
    value: "Morocco",
    label: "Morocco",
  },
  {
    name: "Mozambique",
    dial_code: "+258",
    code: "MZ",
    unicodeFlag: "",
    value: "Mozambique",
    label: "Mozambique",
  },
  {
    name: "Myanmar",
    dial_code: "+95",
    code: "MM",
    unicodeFlag: "",
    value: "Myanmar",
    label: "Myanmar",
  },
  {
    name: "Namibia",
    dial_code: "+264",
    code: "NA",
    unicodeFlag: "",
    value: "Namibia",
    label: "Namibia",
  },
  {
    name: "Nauru",
    dial_code: "+674",
    code: "NR",
    unicodeFlag: "",
    value: "Nauru",
    label: "Nauru",
  },
  {
    name: "Nepal",
    dial_code: "+977",
    code: "NP",
    unicodeFlag: "",
    value: "Nepal",
    label: "Nepal",
  },
  {
    name: "Netherlands",
    dial_code: "+31",
    code: "NL",
    unicodeFlag: "",
    value: "Netherlands",
    label: "Netherlands",
  },
  {
    name: "New Caledonia",
    dial_code: "+687",
    code: "NC",
    unicodeFlag: "",
    value: "New Caledonia",
    label: "New Caledonia",
  },
  {
    name: "New Zealand",
    dial_code: "+64",
    code: "NZ",
    unicodeFlag: "",
    value: "New Zealand",
    label: "New Zealand",
  },
  {
    name: "Nicaragua",
    dial_code: "+505",
    code: "NI",
    unicodeFlag: "",
    value: "Nicaragua",
    label: "Nicaragua",
  },
  {
    name: "Niger",
    dial_code: "+227",
    code: "NE",
    unicodeFlag: "",
    value: "Niger",
    label: "Niger",
  },
  {
    name: "Nigeria",
    dial_code: "+234",
    code: "NG",
    unicodeFlag: "",
    value: "Nigeria",
    label: "Nigeria",
  },
  {
    name: "Niue",
    dial_code: "+683",
    code: "NU",
    unicodeFlag: "",
    value: "Niue",
    label: "Niue",
  },
  {
    name: "Norfolk Island",
    dial_code: "+672",
    code: "NF",
    unicodeFlag: "",
    value: "Norfolk Island",
    label: "Norfolk Island",
  },
  {
    name: "Northern Mariana Islands",
    dial_code: "+1 670",
    code: "MP",
    unicodeFlag: "",
    value: "Northern Mariana Islands",
    label: "Northern Mariana Islands",
  },
  {
    name: "Norway",
    dial_code: "+47",
    code: "NO",
    unicodeFlag: "",
    value: "Norway",
    label: "Norway",
  },
  {
    name: "Oman",
    dial_code: "+968",
    code: "OM",
    unicodeFlag: "",
    value: "Oman",
    label: "Oman",
  },
  {
    name: "Pakistan",
    dial_code: "+92",
    code: "PK",
    unicodeFlag: "",
    value: "Pakistan",
    label: "Pakistan",
  },
  {
    name: "Palau",
    dial_code: "+680",
    code: "PW",
    unicodeFlag: "",
    value: "Palau",
    label: "Palau",
  },
  {
    name: "Palestinian Territory, Occupied",
    dial_code: "+970",
    code: "PS",
    unicodeFlag: "",
    value: "Palestinian Territory, Occupied",
    label: "Palestinian Territory, Occupied",
  },
  {
    name: "Panama",
    dial_code: "+507",
    code: "PA",
    unicodeFlag: "",
    value: "Panama",
    label: "Panama",
  },
  {
    name: "Papua New Guinea",
    dial_code: "+675",
    code: "PG",
    unicodeFlag: "",
    value: "Papua New Guinea",
    label: "Papua New Guinea",
  },
  {
    name: "Paraguay",
    dial_code: "+595",
    code: "PY",
    unicodeFlag: "",
    value: "Paraguay",
    label: "Paraguay",
  },
  {
    name: "Peru",
    dial_code: "+51",
    code: "PE",
    unicodeFlag: "",
    value: "Peru",
    label: "Peru",
  },
  {
    name: "Philippines",
    dial_code: "+63",
    code: "PH",
    unicodeFlag: "",
    value: "Philippines",
    label: "Philippines",
  },
  {
    name: "Pitcairn",
    dial_code: "+872",
    code: "PN",
    unicodeFlag: "",
    value: "Pitcairn",
    label: "Pitcairn",
  },
  {
    name: "Poland",
    dial_code: "+48",
    code: "PL",
    unicodeFlag: "",
    value: "Poland",
    label: "Poland",
  },
  {
    name: "Portugal",
    dial_code: "+351",
    code: "PT",
    unicodeFlag: "",
    value: "Portugal",
    label: "Portugal",
  },
  {
    name: "Puerto Rico",
    dial_code: "+1 939",
    code: "PR",
    unicodeFlag: "",
    value: "Puerto Rico",
    label: "Puerto Rico",
  },
  {
    name: "Qatar",
    dial_code: "+974",
    code: "QA",
    unicodeFlag: "",
    value: "Qatar",
    label: "Qatar",
  },
  {
    name: "Romania",
    dial_code: "+40",
    code: "RO",
    unicodeFlag: "",
    value: "Romania",
    label: "Romania",
  },
  {
    name: "Russia",
    dial_code: "+7",
    code: "RU",
    unicodeFlag: "",
    value: "Russia",
    label: "Russia",
  },
  {
    name: "Rwanda",
    dial_code: "+250",
    code: "RW",
    unicodeFlag: "",
    value: "Rwanda",
    label: "Rwanda",
  },
  {
    name: "Réunion",
    dial_code: "+262",
    code: "RE",
    unicodeFlag: "",
    value: "Réunion",
    label: "Réunion",
  },
  {
    name: "Saint Barthélemy",
    dial_code: "+590",
    code: "BL",
    unicodeFlag: "",
    value: "Saint Barthélemy",
    label: "Saint Barthélemy",
  },
  {
    name: "Saint Helena, Ascension and Tristan Da Cunha",
    dial_code: "+290",
    code: "SH",
    unicodeFlag: "",
    value: "Saint Helena, Ascension and Tristan Da Cunha",
    label: "Saint Helena, Ascension and Tristan Da Cunha",
  },
  {
    name: "Saint Kitts and Nevis",
    dial_code: "+1 869",
    code: "KN",
    unicodeFlag: "",
    value: "Saint Kitts and Nevis",
    label: "Saint Kitts and Nevis",
  },
  {
    name: "Saint Lucia",
    dial_code: "+1 758",
    code: "LC",
    unicodeFlag: "",
    value: "Saint Lucia",
    label: "Saint Lucia",
  },
  {
    name: "Saint Martin",
    dial_code: "+590",
    code: "MF",
    unicodeFlag: "",
    value: "Saint Martin",
    label: "Saint Martin",
  },
  {
    name: "Saint Pierre and Miquelon",
    dial_code: "+508",
    code: "PM",
    unicodeFlag: "",
    value: "Saint Pierre and Miquelon",
    label: "Saint Pierre and Miquelon",
  },
  {
    name: "Saint Vincent and the Grenadines",
    dial_code: "+1 784",
    code: "VC",
    unicodeFlag: "",
    value: "Saint Vincent and the Grenadines",
    label: "Saint Vincent and the Grenadines",
  },
  {
    name: "Samoa",
    dial_code: "+685",
    code: "WS",
    unicodeFlag: "",
    value: "Samoa",
    label: "Samoa",
  },
  {
    name: "San Marino",
    dial_code: "+378",
    code: "SM",
    unicodeFlag: "",
    value: "San Marino",
    label: "San Marino",
  },
  {
    name: "Sao Tome and Principe",
    dial_code: "+239",
    code: "ST",
    unicodeFlag: "",
    value: "Sao Tome and Principe",
    label: "Sao Tome and Principe",
  },
  {
    name: "Saudi Arabia",
    dial_code: "+966",
    code: "SA",
    unicodeFlag: "",
    value: "Saudi Arabia",
    label: "Saudi Arabia",
  },
  {
    name: "Senegal",
    dial_code: "+221",
    code: "SN",
    unicodeFlag: "",
    value: "Senegal",
    label: "Senegal",
  },
  {
    name: "Serbia",
    dial_code: "+381",
    code: "RS",
    unicodeFlag: "",
    value: "Serbia",
    label: "Serbia",
  },
  {
    name: "Seychelles",
    dial_code: "+248",
    code: "SC",
    unicodeFlag: "",
    value: "Seychelles",
    label: "Seychelles",
  },
  {
    name: "Sierra Leone",
    dial_code: "+232",
    code: "SL",
    unicodeFlag: "",
    value: "Sierra Leone",
    label: "Sierra Leone",
  },
  {
    name: "Singapore",
    dial_code: "+65",
    code: "SG",
    unicodeFlag: "",
    value: "Singapore",
    label: "Singapore",
  },
  {
    name: "Slovakia",
    dial_code: "+421",
    code: "SK",
    unicodeFlag: "",
    value: "Slovakia",
    label: "Slovakia",
  },
  {
    name: "Slovenia",
    dial_code: "+386",
    code: "SI",
    unicodeFlag: "",
    value: "Slovenia",
    label: "Slovenia",
  },
  {
    name: "Solomon Islands",
    dial_code: "+677",
    code: "SB",
    unicodeFlag: "",
    value: "Solomon Islands",
    label: "Solomon Islands",
  },
  {
    name: "Somalia",
    dial_code: "+252",
    code: "SO",
    unicodeFlag: "",
    value: "Somalia",
    label: "Somalia",
  },
  {
    name: "South Africa",
    dial_code: "+27",
    code: "ZA",
    unicodeFlag: "",
    value: "South Africa",
    label: "South Africa",
  },
  {
    name: "South Georgia and the South Sandwich Islands",
    dial_code: "+500",
    code: "GS",
    unicodeFlag: "",
    value: "South Georgia and the South Sandwich Islands",
    label: "South Georgia and the South Sandwich Islands",
  },
  {
    name: "Spain",
    dial_code: "+34",
    code: "ES",
    unicodeFlag: "",
    value: "Spain",
    label: "Spain",
  },
  {
    name: "Sri Lanka",
    dial_code: "+94",
    code: "LK",
    unicodeFlag: "",
    value: "Sri Lanka",
    label: "Sri Lanka",
  },
  {
    name: "Sudan",
    dial_code: "+249",
    code: "SD",
    unicodeFlag: "",
    value: "Sudan",
    label: "Sudan",
  },
  {
    name: "Suriname",
    dial_code: "+597",
    code: "SR",
    unicodeFlag: "",
    value: "Suriname",
    label: "Suriname",
  },
  {
    name: "Svalbard and Jan Mayen",
    dial_code: "+47",
    code: "SJ",
    unicodeFlag: "",
    value: "Svalbard and Jan Mayen",
    label: "Svalbard and Jan Mayen",
  },
  {
    name: "Swaziland",
    dial_code: "+268",
    code: "SZ",
    unicodeFlag: "",
    value: "Swaziland",
    label: "Swaziland",
  },
  {
    name: "Sweden",
    dial_code: "+46",
    code: "SE",
    unicodeFlag: "",
    value: "Sweden",
    label: "Sweden",
  },
  {
    name: "Switzerland",
    dial_code: "+41",
    code: "CH",
    unicodeFlag: "",
    value: "Switzerland",
    label: "Switzerland",
  },
  {
    name: "Syrian Arab Republic",
    dial_code: "+963",
    code: "SY",
    unicodeFlag: "",
    value: "Syrian Arab Republic",
    label: "Syrian Arab Republic",
  },
  {
    name: "Taiwan, Province of China",
    dial_code: "+886",
    code: "TW",
    unicodeFlag: "",
    value: "Taiwan, Province of China",
    label: "Taiwan, Province of China",
  },
  {
    name: "Tajikistan",
    dial_code: "+992",
    code: "TJ",
    unicodeFlag: "",
    value: "Tajikistan",
    label: "Tajikistan",
  },
  {
    name: "Tanzania, United Republic of",
    dial_code: "+255",
    code: "TZ",
    unicodeFlag: "",
    value: "Tanzania, United Republic of",
    label: "Tanzania, United Republic of",
  },
  {
    name: "Thailand",
    dial_code: "+66",
    code: "TH",
    unicodeFlag: "",
    value: "Thailand",
    label: "Thailand",
  },
  {
    name: "Timor-Leste",
    dial_code: "+670",
    code: "TL",
    unicodeFlag: "",
    value: "Timor-Leste",
    label: "Timor-Leste",
  },
  {
    name: "Togo",
    dial_code: "+228",
    code: "TG",
    unicodeFlag: "",
    value: "Togo",
    label: "Togo",
  },
  {
    name: "Tokelau",
    dial_code: "+690",
    code: "TK",
    unicodeFlag: "",
    value: "Tokelau",
    label: "Tokelau",
  },
  {
    name: "Tonga",
    dial_code: "+676",
    code: "TO",
    unicodeFlag: "",
    value: "Tonga",
    label: "Tonga",
  },
  {
    name: "Trinidad and Tobago",
    dial_code: "+1 868",
    code: "TT",
    unicodeFlag: "",
    value: "Trinidad and Tobago",
    label: "Trinidad and Tobago",
  },
  {
    name: "Tunisia",
    dial_code: "+216",
    code: "TN",
    unicodeFlag: "",
    value: "Tunisia",
    label: "Tunisia",
  },
  {
    name: "Turkey",
    dial_code: "+90",
    code: "TR",
    unicodeFlag: "",
    value: "Turkey",
    label: "Turkey",
  },
  {
    name: "Turkmenistan",
    dial_code: "+993",
    code: "TM",
    unicodeFlag: "",
    value: "Turkmenistan",
    label: "Turkmenistan",
  },
  {
    name: "Turks and Caicos Islands",
    dial_code: "+1 649",
    code: "TC",
    unicodeFlag: "",
    value: "Turks and Caicos Islands",
    label: "Turks and Caicos Islands",
  },
  {
    name: "Tuvalu",
    dial_code: "+688",
    code: "TV",
    unicodeFlag: "",
    value: "Tuvalu",
    label: "Tuvalu",
  },
  {
    name: "Uganda",
    dial_code: "+256",
    code: "UG",
    unicodeFlag: "",
    value: "Uganda",
    label: "Uganda",
  },
  {
    name: "Ukraine",
    dial_code: "+380",
    code: "UA",
    unicodeFlag: "",
    value: "Ukraine",
    label: "Ukraine",
  },
  {
    name: "United Arab Emirates",
    dial_code: "+971",
    code: "AE",
    unicodeFlag: "",
    value: "United Arab Emirates",
    label: "United Arab Emirates",
  },
  {
    name: "United Kingdom",
    dial_code: "+44",
    code: "GB",
    unicodeFlag: "",
    value: "United Kingdom",
    label: "United Kingdom",
  },
  {
    name: "United States",
    dial_code: "+1",
    code: "US",
    unicodeFlag: "",
    value: "United States",
    label: "United States",
  },
  {
    name: "Uruguay",
    dial_code: "+598",
    code: "UY",
    unicodeFlag: "",
    value: "Uruguay",
    label: "Uruguay",
  },
  {
    name: "Uzbekistan",
    dial_code: "+998",
    code: "UZ",
    unicodeFlag: "",
    value: "Uzbekistan",
    label: "Uzbekistan",
  },
  {
    name: "Vanuatu",
    dial_code: "+678",
    code: "VU",
    unicodeFlag: "",
    value: "Vanuatu",
    label: "Vanuatu",
  },
  {
    name: "Venezuela, Bolivarian Republic of",
    dial_code: "+58",
    code: "VE",
    unicodeFlag: "",
    value: "Venezuela, Bolivarian Republic of",
    label: "Venezuela, Bolivarian Republic of",
  },
  {
    name: "Viet Nam",
    dial_code: "+84",
    code: "VN",
    unicodeFlag: "",
    value: "Viet Nam",
    label: "Viet Nam",
  },
  {
    name: "Virgin Islands, British",
    dial_code: "+1 284",
    code: "VG",
    unicodeFlag: "",
    value: "Virgin Islands, British",
    label: "Virgin Islands, British",
  },
  {
    name: "Virgin Islands, U.S.",
    dial_code: "+1 340",
    code: "VI",
    unicodeFlag: "",
    value: "Virgin Islands, U.S.",
    label: "Virgin Islands, U.S.",
  },
  {
    name: "Wallis and Futuna",
    dial_code: "+681",
    code: "WF",
    unicodeFlag: "",
    value: "Wallis and Futuna",
    label: "Wallis and Futuna",
  },
  {
    name: "Yemen",
    dial_code: "+967",
    code: "YE",
    unicodeFlag: "",
    value: "Yemen",
    label: "Yemen",
  },
  {
    name: "Zambia",
    dial_code: "+260",
    code: "ZM",
    unicodeFlag: "",
    value: "Zambia",
    label: "Zambia",
  },
  {
    name: "Zimbabwe",
    dial_code: "+263",
    code: "ZW",
    unicodeFlag: "",
    value: "Zimbabwe",
    label: "Zimbabwe",
  },
  {
    name: "land Islands",
    dial_code: "",
    code: "AX",
    unicodeFlag: "",
    value: "land Islands",
    label: "land Islands",
  },
];

export default COUNTRY_DIAL_ROWS;
